/**
 * Tokens per network
 * With search ability
 */
import { useEffect, useState } from 'react';
import { ITokenCoin } from '@kattana-io/common';
import { KattanaAPI } from '../../../store/createStore';

const useGetFeaturedTokensByNetwork = (network: string, query: string) => {
  const [tokens, setTokens] = useState<ITokenCoin[]>([]);

  useEffect(() => {
    const controller = new AbortController();

    KattanaAPI.featuredTokensPerNetwork(network, controller)
      .then((data: any[] | null) => {
        const tkns = data?.map((t) => {
          t.chain = t.network;
          return t;
        });

        setTokens(tkns || []);
      })
      .catch((err) => {
        console.warn('tokensPerNetwork:', err);
        setTokens([]);
      });

    return () => {
      controller.abort();
    };
  }, [network, query]);

  return tokens;
};

export default useGetFeaturedTokensByNetwork;
